import { MEDIA_QUERIES } from '@student-coin/coinpaper-components';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 0.5rem;
  row-gap: 0.5rem;
  @media ${MEDIA_QUERIES.tablet} {
    column-gap: 1rem;
  }
`;

export const Item = styled.span<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize.small};
  background: ${({ active }) => (active ? '#000' : '#fff')};
  color: ${({ active }) => (active ? '#fff' : '#000')};
  height: 32px;
  border: 2px solid #000;
  border-radius: 40px;
  cursor: pointer;
  transition: 0.2s ease-in-out;
  &:hover {
    background: #000;
    color: #fff;
  }
  @media ${MEDIA_QUERIES.tablet} {
    font-size: ${({ theme }) => theme.fontSize.regular};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
  }
`;
